import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import CustomerValidations from 'scaleflow/validators/customer';

export interface CustomersFormSignature {
  // The arguments accepted by the component
  Args: {
    customer: any; // Customer model
    onSave?: (customer: any) => Promise<void>;
    onCancel?: () => void;
  };
  // Any blocks yielded by the component
  Blocks: {
    default: [];
  };
  // The element to which `...attributes` is applied in the component template
  Element: null;
}

export default class CustomersFormComponent extends Component<CustomersFormSignature> {
  CustomerValidations = CustomerValidations;
  @tracked changeset: any;

  @action
  async submitForm(changeset: any, event: Event): Promise<void> {
    event.preventDefault();

    const isValid = await changeset.validate();

    if (isValid) {
      // Apply changes to the model
      await changeset.save();

      // Call the parent's onSave action
      if (this.args.onSave) {
        await this.args.onSave(this.args.customer);
      }
    }
  }

  @action
  handleBlur(changeset: any): void {
    // This is for the Atoms::Forms::Input component
    changeset.validate();
  }

  get isEdit(): boolean {
    return !!this.args.customer?.id;
  }

  @action
  cancelForm(changeset: any): void {
    changeset.rollback();
    if (this.args.onCancel) {
      this.args.onCancel();
    }
  }
}
